import React, { useState } from "react";
import {
  Box, Container, Typography, TextField, Button,
  Grid, Alert, Divider, Stack, Paper, Chip,
} from "@mui/material";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import SendIcon from "@mui/icons-material/Send";
import { BRAND } from "../theme";

export default function Contacto() {
  const [form, setForm] = useState({ nombre: "", email: "", mensaje: "" });
  const [sent, setSent] = useState(false);

  const handle = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    const mailto = `mailto:datascience@nodoxxi.cl?subject=Datos para la Democracia — Contacto de ${form.nombre}&body=${encodeURIComponent(form.mensaje)}%0A%0AResponder a: ${form.email}`;
    window.location.href = mailto;
    setSent(true);
  };

  return (
    <Box sx={{ bgcolor: BRAND.bg, minHeight: "80vh", py: { xs: 5, md: 8 } }}>
      <Container maxWidth="md">
        <Chip
          label="Escríbenos"
          size="small"
          sx={{ bgcolor: `${BRAND.nodoBlue}12`, color: BRAND.nodoBlue, fontWeight: 700, mb: 2 }}
        />
        <Typography variant="h3" mb={1.25} color={BRAND.text}>
          Contacto
        </Typography>
        <Typography color="text.secondary" mb={5} sx={{ maxWidth: 520, lineHeight: 1.75 }}>
          ¿Tienes sugerencias, datos adicionales o quieres colaborar? Escríbenos.
        </Typography>

        <Grid container spacing={4}>
          <Grid size={{ xs: 12, md: 7 }}>
            <Paper elevation={0} sx={{ p: { xs: 2.5, md: 3.5 } }}>
              <form onSubmit={submit}>
                <Stack spacing={2.5}>
                  <TextField
                    label="Nombre"
                    name="nombre"
                    value={form.nombre}
                    onChange={handle}
                    required
                    fullWidth
                    size="small"
                  />
                  <TextField
                    label="Correo electrónico"
                    name="email"
                    type="email"
                    value={form.email}
                    onChange={handle}
                    required
                    fullWidth
                    size="small"
                  />
                  <TextField
                    label="Mensaje"
                    name="mensaje"
                    value={form.mensaje}
                    onChange={handle}
                    required
                    fullWidth
                    multiline
                    rows={5}
                    size="small"
                  />
                  <Button type="submit" variant="contained" size="large" endIcon={<SendIcon />}>
                    Enviar mensaje
                  </Button>
                  {sent && <Alert severity="success">Se abrió tu cliente de correo con el mensaje.</Alert>}
                </Stack>
              </form>
            </Paper>
          </Grid>

          <Grid size={{ xs: 12, md: 5 }}>
            <Box>
              <Typography fontWeight={700} mb={2} color={BRAND.text}>
                Sobre la plataforma
              </Typography>
              <Typography variant="body2" color="text.secondary" lineHeight={1.8} mb={3}>
                Esta plataforma es desarrollada por Fundación Nodo XXI con el apoyo de
                Friedrich-Ebert-Stiftung (FES Chile). El acceso al repositorio está controlado
                y los colaboradores autorizados reciben invitación directa.
              </Typography>

              <Divider sx={{ mb: 2 }} />

              <Stack spacing={1.5}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                  <Box
                    sx={{
                      width: 34, height: 34, borderRadius: 2, flexShrink: 0,
                      bgcolor: `${BRAND.nodoBlue}0F`,
                      display: "flex", alignItems: "center", justifyContent: "center",
                    }}
                  >
                    <EmailOutlinedIcon sx={{ color: BRAND.nodoBlue, fontSize: 18 }} />
                  </Box>
                  <Typography
                    component="a"
                    href="mailto:datascience@nodoxxi.cl"
                    variant="body2"
                    color="text.secondary"
                    sx={{ textDecoration: "none", overflowWrap: "anywhere", "&:hover": { textDecoration: "underline" } }}
                  >
                    datascience@nodoxxi.cl
                  </Typography>
                </Box>
              </Stack>

              <Box
                mt={3}
                sx={{
                  p: 2,
                  borderRadius: 3,
                  border: `1.5px dashed ${BRAND.border}`,
                  bgcolor: "#F8FAFD",
                }}
              >
                <Typography variant="caption" color="text.secondary" lineHeight={1.7}>
                  Los datos publicados provienen de fuentes oficiales (Banco Central, INE, FONASA,
                  SERMIG, CEAD, Fiscalía). La elaboración e interpretación es responsabilidad de
                  Fundación Nodo XXI.
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
